module.exports = __webpack_public_path__ + "img/poly-8.fe26ae72.png";